var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slash-commands" }, [
    _c(
      "div",
      { staticClass: "items" },
      _vm._l(_vm.getItems(), function (command, index) {
        return _c(
          "div",
          {
            key: index,
            ref: "item-card-" + index,
            refInFor: true,
            staticClass: "item-card",
            class: {
              selected: _vm.pointerIndex === index,
              hoverSelected: _vm.pointerIndex === index,
            },
          },
          [
            _c("div", { staticClass: "title-wrapper" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(command.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "shortcut" }, [
                _vm._v(_vm._s(command.shortcut)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message-preview" }, [
              _vm._v(_vm._s(command.description)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }